import Topheader from "../Components/Topheader";
import { FaArrowRight } from "react-icons/fa6";
import React, { useEffect } from "react";
import Services from "./Coureses";


const About = () => {

  useEffect(() => {
    const observer = new IntersectionObserver((entries) => {
      // loop over all the entries
      entries.forEach((entry) => {
        console.log(entry);
        // use a conditional to check if the entry is intersection
        if (entry.isIntersecting) {
          // add show class
          entry.target.classList.add("show");
        } else {
          // remove when not intersecting
          entry.target.classList.remove("show");
        }
      });
    });
    
    const hiddenElements = document.querySelectorAll(".hidden");
    hiddenElements.forEach((el) => observer.observe(el));    
  })

  return (
    <>
      {/* <Topheader /> */}
      

      <section className="page-header">
        <div className="page-header__bg_1"
        >
          
        </div>
        {/* <div
          className="page-header__gradient"
          style={{
            backgroundImage:
              "url(https://bracketweb.com/ontechwp/wp-content/uploads/2023/07/page-header-gradient-bg.png)",
          }}
        ></div> */}
        <div className="shape1 float-bob-x">
          <img src=" ./images/sttsbanner.png" alt="banner shape" />
        </div>
        <div className="container">
          <div className="page-header__inner text-center">
            <h2>About</h2>

            <ul className="thm-breadcrumb list-unstyled ml-0">
              {/* Breadcrumb NavXT 7.2.0 */}
              <li className="home">
                <span property="itemListElement" typeof="ListItem">
                  <a
                    property="item"
                    typeof="WebPage"
                    title="Go to Ontech."
                    href="/"
                    className="home"
                  >
                    <span property="name">Home</span>
                  </a>
                  <meta property="position" content="1" />
                </span>
              </li>
              <li className="post post-page current-item">
                <span property="itemListElement" typeof="ListItem">
                  <span property="name" className="post post-page current-item">
                    About
                  </span>
                  <meta property="url" content="" />
                  <meta property="position" content="2" />
                </span>
              </li>
            </ul>
          </div>
        </div>
      </section>

      <section
        class="elementor-section elementor-top-section elementor-element elementor-element-1acfe089 elementor-section-full_width elementor-section-height-default elementor-section-height-default"
        data-id="1acfe089"
        data-element_type="section"
      >

<div class="sec-title__tagline" style={{marginLeft:"672px",marginBottom:"-50px",marginTop:"50px"}}>
              <div class="inner">
                <div class="round-box">
                  <img
                    decoding="async"
                    src="https://bracketweb.com/ontechwp/wp-content/uploads/2023/07/sec-title-shape.png"
                    alt="alt"
                    title="sec-title-shape"
                  />
                </div>
                <div class="text">
                  <p class="sec-title__sub-title">About Us</p>
                </div>
              </div>
            </div>
       

      <div class="container_founder hidden">
        <div class="image-container_founder">
          <img src="assets1/WhatsApp Image 2024-02-09 at 16.35.45 (1).jpeg" alt="Image" style={{borderRadius:"50%",borderColor:"#FFB237",borderWidth:"10px"}}/>
        </div>
        <div class="content-container_founder">
          <h2><b>Welcome to Shaw Tech Training & Services</b></h2>
          <br/>
          <h2 class="founder-name_founder">Meet our Founder/Mentor <br/><b>Jyoti Prakash Shaw</b></h2>
          <p style={{fontSize:"18px"}}>
            His educational journey includes obtaining a degree in Mechanical Engineering (BE) from Birla Institute of Technology in Ranchi. Complementing his academic achievements, he underwent valuable training at renowned institutions, including Tata Engineering at TATA, MICO in Kolkata, and TVS Suzuki in Bangalore. These experiences further enriched his practical knowledge and skills. Additionally, he honed his expertise through training at Cummins India Ltd in Jamshedpur. This comprehensive background demonstrates not only his commitment to academic excellence but also his hands-on experience in diverse industrial settings.
          </p>
        </div>
      </div>

        <div class="elementor-container elementor-column-gap-no">
          <div
            class="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-7a38f82e"
            data-id="7a38f82e"
            data-element_type="column"
          >
            <div class="elementor-widget-wrap elementor-element-populated">
              <div
                class="elementor-element elementor-element-65e6ab19 elementor-widget elementor-widget-ontech-about"
                data-id="65e6ab19"
                data-element_type="widget"
                data-widget_type="ontech-about.default"
              >
                <div class="elementor-widget-container">
                  <section class="about-three" style={{marginLeft:"30px"}}>
                    <div class="shape4">
                      <img
                        decoding="async"
                        src="https://bracketweb.com/ontechwp/wp-content/uploads/2023/07/about-v3-shape3.png"
                        alt="alt"
                        title="about-v3-shape3"
                      />{" "}
                    </div>
                    <div class="shape5">
                      <img
                        decoding="async"
                        src="https://bracketweb.com/ontechwp/wp-content/uploads/2023/07/about-v3-shape4.png"
                        alt="alt"
                        title="about-v3-shape4"
                      />{" "}
                    </div>
                    <div class="container">
                      <div class="row">
                        <div class="col-xl-5">
                          <div class="about-three__img clearfix">
                            <div class="shape2"></div>
                            <div class="shape3"></div>
                            <div
                              class="about-three__img1 wow fadeInLeft"
                              data-wow-delay=".3s"
                            >
                              <img
                                decoding="async"
                                src="/assets1/vision1.jpg"
                                alt="alt"
                                title="about-v3-img1"
                              />{" "}
                            </div>

                            <div
                              class="about-three__img2 wow fadeInUp"
                              data-wow-delay=".3s"
                            >
                              <div class="inner">
                                <img
                                  decoding="async"
                                  src="/assets1/vision2.jpg"
                                  alt="alt"
                                  title="about-v3-img2"
                                />{" "}
                              </div>
                              <div class="shape1 rotate-me">
                                {/* <img
                                  decoding="async"
                                  src="./study.png"
                                  alt="alt"
                                  title="about-v3-shape1"
                                  style={{
                                    marginBottom: "22px",
                                    marginRight: "21px",
                                  }}
                                />{" "} */}
                                <svg xmlns="http://www.w3.org/2000/svg" width="6rem" height="10rem" viewBox="0 0 56 56"><path fill="#FFB237" d="M28 50.828c.61 0 1.172-.07 1.805-.117l1.36 2.578c.257.516.773.797 1.405.703c.586-.117 1.008-.539 1.078-1.172l.422-2.836c1.149-.304 2.297-.75 3.422-1.242l2.11 1.899c.445.422 1.007.515 1.593.187c.516-.281.727-.844.61-1.453l-.586-2.812a21.53 21.53 0 0 0 2.789-2.32l2.625 1.1c.586.235 1.125.118 1.57-.421c.399-.422.445-1.031.117-1.547l-1.523-2.437c.703-.985 1.266-2.04 1.805-3.165l2.86.141c.608.023 1.124-.305 1.335-.89c.187-.587 0-1.149-.492-1.524l-2.227-1.781c.305-1.125.54-2.344.633-3.61l2.719-.843c.586-.211.96-.657.96-1.29c0-.609-.374-1.054-.96-1.265l-2.72-.867c-.093-1.266-.327-2.438-.632-3.586l2.226-1.805c.493-.351.68-.89.493-1.476c-.211-.586-.727-.915-1.336-.891l-2.86.117c-.538-1.125-1.1-2.18-1.804-3.164l1.524-2.437c.327-.493.28-1.102-.118-1.524c-.445-.539-.984-.68-1.57-.422l-2.625 1.055a25.884 25.884 0 0 0-2.79-2.297l.587-2.789c.117-.633-.094-1.195-.61-1.477c-.586-.304-1.148-.257-1.593.211l-2.11 1.852a27.105 27.105 0 0 0-3.422-1.219l-.422-2.836c-.07-.61-.492-1.054-1.078-1.148c-.633-.094-1.148.164-1.406.68l-1.36 2.578c-.632-.047-1.195-.094-1.804-.094c-.633 0-1.195.047-1.852.094l-1.335-2.578c-.258-.516-.774-.774-1.43-.68c-.586.094-.985.539-1.078 1.148l-.399 2.813a28.27 28.27 0 0 0-3.422 1.242l-2.109-1.852c-.469-.468-1.031-.515-1.594-.21c-.515.28-.726.843-.61 1.476l.587 2.79a24.044 24.044 0 0 0-2.813 2.296l-2.601-1.055c-.586-.258-1.149-.117-1.594.422a1.235 1.235 0 0 0-.117 1.5L9.18 15.04c-.703.984-1.266 2.04-1.805 3.164l-2.883-.117c-.61-.023-1.125.305-1.312.89c-.188.587-.024 1.126.468 1.477l2.25 1.805c-.304 1.148-.562 2.32-.632 3.586l-2.72.867c-.608.187-.937.633-.937 1.266c0 .632.329 1.078.938 1.289l2.719.867c.07 1.242.328 2.46.633 3.586l-2.25 1.78c-.493.375-.657.938-.47 1.523c.188.586.704.914 1.313.891l2.883-.14c.54 1.124 1.102 2.18 1.781 3.163l-1.5 2.438c-.351.516-.304 1.125.094 1.547c.445.539 1.008.656 1.594.422l2.601-1.102c.868.867 1.829 1.64 2.813 2.32l-.586 2.813c-.117.61.094 1.172.61 1.453c.585.328 1.148.234 1.593-.187l2.086-1.899c1.125.492 2.273.938 3.445 1.242l.399 2.836c.093.633.492 1.055 1.078 1.172c.656.094 1.172-.187 1.43-.703l1.335-2.578c.633.047 1.22.117 1.852.117M33.883 26.5c-1.102-2.953-3.258-4.57-5.953-4.57c-.399 0-.867.047-1.617.21l-6.727-11.484C22.094 9.414 24.953 8.734 28 8.734c10.219 0 18.234 7.758 18.961 17.766ZM8.969 28c0-6.516 3.07-12.258 7.922-15.726l6.773 11.554c-1.266 1.313-1.851 2.742-1.851 4.266c0 1.476.562 2.836 1.851 4.195l-6.937 11.344C11.992 40.14 8.969 34.469 8.969 28m16.148.07c0-1.593 1.36-2.836 2.86-2.836c1.593 0 2.906 1.243 2.906 2.836c0 1.57-1.313 2.86-2.906 2.86c-1.5 0-2.86-1.29-2.86-2.86M28 47.266c-3.117 0-6.023-.727-8.578-1.992L26.312 34c.727.188 1.22.234 1.618.234c2.718 0 4.875-1.664 5.953-4.687H46.96c-.75 9.96-8.766 17.719-18.961 17.719"/></svg>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div class="col-xl-7 hidden">
                          <div class="about-three__content">
                            <div class="sec-title">
                              <div class="sec-title__tagline">
                                <div class="inner">
                                  <div class="round-box">
                                    <img
                                      decoding="async"
                                      src="https://bracketweb.com/ontechwp/wp-content/uploads/2023/07/sec-title-shape.png"
                                      alt="alt"
                                      title="sec-title-shape"
                                    />{" "}
                                  </div>
                                  <div class="text">
                                    <p class="sec-title__sub-title">
                                      Our Vision
                                    </p>
                                  </div>
                                </div>
                              </div>
                              <h2 class="sec-title__title">
                                Our Vision <br /> Specializes in Design
                                Solutions
                              </h2>
                            </div>

                            <div class="about-three__content-text1">
                              <p class="summary" style={{textAlign:"justify"}}>
                                Our vision for professional development is to
                                make the most of our human talent and potential.
                                We aim to inform, educate, and inspire people to
                                reach their professional goals, creating a work
                                environment that both challenges and supports
                                individuals. Our goal is to achieve success
                                faster and easier, with less stress and more
                                enjoyment. We engage in providing skill
                                development training, offering affordable
                                employment-oriented and placement-linked
                                training to youth across the country. This
                                contributes towards improving the socio-economic
                                status of the underprivileged. We are proud to
                                introduce the first exclusive CAD/CAM Training
                                Institute along with a CNC Training facility
                                featuring Virtual Machines (Fanuc Oi series
                                controller) in North Odisha. This training
                                program is available for engineering students
                                and professionals in the field of designing,
                                covering CAD/CAM software for the Civil and
                                Mechanical branches.
                              </p>
                            </div>

                          

                            <div class="about-three__content-text4">
                              <div class="img-box">
                                <img
                                  decoding="async"
                                  src=" ./images/study.png"
                                  alt="alt"
                                  title="about-v3-shape2"
                                  style={{ height: "40px", width: "50px" }}
                                />
                              </div>
                              <div class="text-box">
                                <p>
                                  FOR YOUR Knowledge, WE MADE THINGS EASIER
                                  TODAY
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </section>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section
        class="elementor-section elementor-top-section elementor-element elementor-element-4113eccd elementor-section-full_width elementor-section-height-default elementor-section-height-default"
        data-id="4113eccd"
        data-element_type="section"
      >
        <div class="elementor-container elementor-column-gap-no">
          <div
            class="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-1a23ca5"
            data-id="1a23ca5"
            data-element_type="column"
          >
            <div class="elementor-widget-wrap elementor-element-populated">
              <div
                class="elementor-element elementor-element-605f9883 elementor-widget elementor-widget-ontech-service"
                data-id="605f9883"
                data-element_type="widget"
                data-widget_type="ontech-service.default"
              >
                <div class="elementor-widget-container hidden">
                  <section class="intro-one style3">
                    <div class="container">
                      <div class="row">
                        <div
                          class="col-xl-3 col-lg-3 wow animated fadeInUp"
                          data-wow-delay="0.1s"
                        >
                          <div class="intro-one__single">
                            <div class="intro-one__single-img">
                              <div class="inner">
                                <img
                                  decoding="async"
                                  src="assets1/mech1.jpeg"
                                  alt="alt"
                                  title="intro-v1-img4"
                                />{" "}
                              </div>
                              {/* <div class="icon-box">
                                                                <span aria-hidden="true" class="  icon-privacy"></span> 
                                                                </div> */}
                            </div>

                            <a href="/Courses">
                              <div
                                class="intro-one__single-content text-center"
                                style={{
                                  marginLeft: "5px",
                                  marginRight: "5px",
                                }}
                              >
                                <div class="shape1">
                                  <img
                                    decoding="async"
                                    src="https://bracketweb.com/ontechwp/wp-content/uploads/2023/07/intro-v1-shape1-2.png"
                                    alt="intro-v1-shape1"
                                    title="intro-v1-shape1"
                                  />{" "}
                                </div>
                                <h2>
                                  <a class="" href="/Courses">
                                    Mechanical
                                  </a>{" "}
                                </h2>
                                <ul
                                  style={{
                                    textAlign: "justify",
                                    marginLeft: "90px",
                                    fontSize: "15px",
                                  }}
                                >
                                  <li>AUTO CAD(ME)</li>
                                  <li>SOILD WORK</li>
                                  <li>CATIA V5</li>
                                  <li>
                                    CREO...
                                    <a href="/Courses">
                                      <FaArrowRight />
                                    </a>
                                  </li>
                                </ul>
                              </div>
                            </a>
                          </div>
                        </div>

                        <div
                          class="col-xl-3 col-lg-3 wow animated fadeInUp"
                          data-wow-delay="0.1s"
                        >
                          <div class="intro-one__single">
                            <div class="intro-one__single-img">
                              <div class="inner">
                                <img
                                  decoding="async"
                                  src="assets1/civil.jpeg"
                                  alt="alt"
                                  title="intro-v1-img5"
                                />{" "}
                              </div>
                              {/* <div class="icon-box">
                                                                <span aria-hidden="true" class="   icon-certified"></span> 
                                                                </div> */}
                            </div>

                            <a href="/Courses">
                              <div
                                class="intro-one__single-content text-center"
                                style={{
                                  marginLeft: "5px",
                                  marginRight: "5px",
                                }}
                              >
                                <div class="shape1">
                                  <img
                                    decoding="async"
                                    src="https://bracketweb.com/ontechwp/wp-content/uploads/2023/07/intro-v1-shape1-2.png"
                                    alt="intro-v1-shape1"
                                    title="intro-v1-shape1"
                                  />{" "}
                                </div>
                                <h2>
                                  <a class=" " href="/Courses">
                                    Civil
                                  </a>{" "}
                                </h2>
                                <ul
                                  style={{
                                    textAlign: "justify",
                                    marginLeft: "90px",
                                    fontSize: "15px",
                                  }}
                                >
                                  <li>AUTO CAD(CV)</li>
                                  <li>CIVIL 3D</li>
                                  <li>STAAD PRO</li>
                                  <li>
                                    ETABS...
                                    <a href="/Courses">
                                      <FaArrowRight />
                                    </a>
                                  </li>
                                </ul>
                              </div>
                            </a>
                          </div>
                        </div>

                        <div
                          class="col-xl-3 col-lg-3 wow animated fadeInUp"
                          data-wow-delay="0.1s"
                        >
                          <div class="intro-one__single">
                            <div class="intro-one__single-img">
                              <div class="inner">
                                <img
                                  decoding="async"
                                  src="assets1/ele.jpeg"
                                  alt="alt"
                                  title="intro-v1-img6"
                                />{" "}
                              </div>
                              {/* <div class="icon-box">
                                                                <span aria-hidden="true" class="   icon-laptop"></span> 
                                                                </div> */}
                            </div>

                            <a href="/Courses">
                              <div
                                class="intro-one__single-content text-center"
                                style={{
                                  marginLeft: "5px",
                                  marginRight: "5px",
                                }}
                              >
                                <div class="shape1">
                                  <img
                                    decoding="async"
                                    src="https://bracketweb.com/ontechwp/wp-content/uploads/2023/07/intro-v1-shape1-2.png"
                                    alt="intro-v1-shape1"
                                    title="intro-v1-shape1"
                                  />{" "}
                                </div>
                                <h2>
                                  <a class="  " href="/Courses">
                                    Electrical
                                  </a>{" "}
                                </h2>
                                <ul
                                  style={{
                                    textAlign: "justify",
                                    marginLeft: "90px",
                                    fontSize: "15px",
                                  }}
                                >
                                  <li>AUTO CAD(ELC)</li>
                                  <li>EPLAN</li>
                                  <li>MATLAB</li>
                                  <li>
                                    PLC...
                                    <a href="/Courses">
                                      <FaArrowRight />
                                    </a>
                                  </li>
                                </ul>
                              </div>
                            </a>
                          </div>
                        </div>

                        <div
                          class="col-xl-3 col-lg-3 wow animated fadeInUp"
                          data-wow-delay="0.1s"
                        >
                          <div class="intro-one__single">
                            <div class="intro-one__single-img">
                              <div class="inner">
                                <img
                                  decoding="async"
                                  src="assets1/cop.jpeg"
                                  alt="alt"
                                  title="intro-v1-img6"
                                />{" "}
                              </div>
                              {/* <div class="icon-box">
                                                                <span aria-hidden="true" class="   icon-laptop"></span>
                                                                 </div> */}
                            </div>

                            <a href="/Courses">
                              <div
                                class="intro-one__single-content text-center"
                                style={{
                                  marginLeft: "5px",
                                  marginRight: "5px",
                                }}
                              >
                                <div class="shape1">
                                  <img
                                    decoding="async"
                                    src="https://bracketweb.com/ontechwp/wp-content/uploads/2023/07/intro-v1-shape1-2.png"
                                    alt="intro-v1-shape1"
                                    title="intro-v1-shape1"
                                  />{" "}
                                </div>
                                <h2>
                                  <a class="  " href="">
                                    Computer
                                  </a>{" "}
                                </h2>
                                <ul
                                  style={{
                                    textAlign: "justify",
                                    marginLeft: "90px",
                                    fontSize: "15px",
                                  }}
                                >
                                  <li>MS OFFICE</li>
                                  <li>TALLY</li>
                                  <li>DCA</li>
                                  <li>
                                    PGDCAD...
                                    <a href="/Courses">
                                      <FaArrowRight />
                                    </a>
                                  </li>
                                </ul>
                              </div>
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </section>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section
        class="elementor-section elementor-top-section elementor-element elementor-element-2499f371 elementor-section-full_width elementor-section-height-default elementor-section-height-default"
        data-id="2499f371"
        data-element_type="section"
      >
        <div class="elementor-container elementor-column-gap-no">
          <div
            class="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-44aa2659"
            data-id="44aa2659"
            data-element_type="column"
          >
            <div class="elementor-widget-wrap elementor-element-populated">
              <div
                class="elementor-element elementor-element-43fa011d elementor-widget elementor-widget-ontech-about"
                data-id="43fa011d"
                data-element_type="widget"
                data-widget_type="ontech-about.default"
              >
                <div class="elementor-widget-container">
                  <section class="support-one support-one--two">
                    <div class="shape4">
                      <img
                        decoding="async"
                        src="https://bracketweb.com/ontechwp/wp-content/uploads/2023/07/support-v1-shape4-1.png"
                        alt="alt"
                        title="support-v1-shape4"
                      />{" "}
                    </div>
                    <div class="container">
                      <div class="row">
                        <div class="col-xl-6">
                          <div class="support-one__img clearfix">
                            <div class="shape5"></div>
                            <div class="shape6"></div>
                            <div class="shape1 rotate-me">
                              {/* <img
                                decoding="async"
                                src="./study.png"
                                alt="alt"
                                title="support-v1-shape1"
                                style={{
                                  marginBottom: "22px",
                                  marginRight: "21px",
                                }}
                              />{" "} */}
                              <svg xmlns="http://www.w3.org/2000/svg" width="6rem" height="10rem" viewBox="0 0 56 56"><path fill="#FFB237" d="M28 50.828c.61 0 1.172-.07 1.805-.117l1.36 2.578c.257.516.773.797 1.405.703c.586-.117 1.008-.539 1.078-1.172l.422-2.836c1.149-.304 2.297-.75 3.422-1.242l2.11 1.899c.445.422 1.007.515 1.593.187c.516-.281.727-.844.61-1.453l-.586-2.812a21.53 21.53 0 0 0 2.789-2.32l2.625 1.1c.586.235 1.125.118 1.57-.421c.399-.422.445-1.031.117-1.547l-1.523-2.437c.703-.985 1.266-2.04 1.805-3.165l2.86.141c.608.023 1.124-.305 1.335-.89c.187-.587 0-1.149-.492-1.524l-2.227-1.781c.305-1.125.54-2.344.633-3.61l2.719-.843c.586-.211.96-.657.96-1.29c0-.609-.374-1.054-.96-1.265l-2.72-.867c-.093-1.266-.327-2.438-.632-3.586l2.226-1.805c.493-.351.68-.89.493-1.476c-.211-.586-.727-.915-1.336-.891l-2.86.117c-.538-1.125-1.1-2.18-1.804-3.164l1.524-2.437c.327-.493.28-1.102-.118-1.524c-.445-.539-.984-.68-1.57-.422l-2.625 1.055a25.884 25.884 0 0 0-2.79-2.297l.587-2.789c.117-.633-.094-1.195-.61-1.477c-.586-.304-1.148-.257-1.593.211l-2.11 1.852a27.105 27.105 0 0 0-3.422-1.219l-.422-2.836c-.07-.61-.492-1.054-1.078-1.148c-.633-.094-1.148.164-1.406.68l-1.36 2.578c-.632-.047-1.195-.094-1.804-.094c-.633 0-1.195.047-1.852.094l-1.335-2.578c-.258-.516-.774-.774-1.43-.68c-.586.094-.985.539-1.078 1.148l-.399 2.813a28.27 28.27 0 0 0-3.422 1.242l-2.109-1.852c-.469-.468-1.031-.515-1.594-.21c-.515.28-.726.843-.61 1.476l.587 2.79a24.044 24.044 0 0 0-2.813 2.296l-2.601-1.055c-.586-.258-1.149-.117-1.594.422a1.235 1.235 0 0 0-.117 1.5L9.18 15.04c-.703.984-1.266 2.04-1.805 3.164l-2.883-.117c-.61-.023-1.125.305-1.312.89c-.188.587-.024 1.126.468 1.477l2.25 1.805c-.304 1.148-.562 2.32-.632 3.586l-2.72.867c-.608.187-.937.633-.937 1.266c0 .632.329 1.078.938 1.289l2.719.867c.07 1.242.328 2.46.633 3.586l-2.25 1.78c-.493.375-.657.938-.47 1.523c.188.586.704.914 1.313.891l2.883-.14c.54 1.124 1.102 2.18 1.781 3.163l-1.5 2.438c-.351.516-.304 1.125.094 1.547c.445.539 1.008.656 1.594.422l2.601-1.102c.868.867 1.829 1.64 2.813 2.32l-.586 2.813c-.117.61.094 1.172.61 1.453c.585.328 1.148.234 1.593-.187l2.086-1.899c1.125.492 2.273.938 3.445 1.242l.399 2.836c.093.633.492 1.055 1.078 1.172c.656.094 1.172-.187 1.43-.703l1.335-2.578c.633.047 1.22.117 1.852.117M33.883 26.5c-1.102-2.953-3.258-4.57-5.953-4.57c-.399 0-.867.047-1.617.21l-6.727-11.484C22.094 9.414 24.953 8.734 28 8.734c10.219 0 18.234 7.758 18.961 17.766ZM8.969 28c0-6.516 3.07-12.258 7.922-15.726l6.773 11.554c-1.266 1.313-1.851 2.742-1.851 4.266c0 1.476.562 2.836 1.851 4.195l-6.937 11.344C11.992 40.14 8.969 34.469 8.969 28m16.148.07c0-1.593 1.36-2.836 2.86-2.836c1.593 0 2.906 1.243 2.906 2.836c0 1.57-1.313 2.86-2.906 2.86c-1.5 0-2.86-1.29-2.86-2.86M28 47.266c-3.117 0-6.023-.727-8.578-1.992L26.312 34c.727.188 1.22.234 1.618.234c2.718 0 4.875-1.664 5.953-4.687H46.96c-.75 9.96-8.766 17.719-18.961 17.719"/></svg>
                            </div>
                            <div class="inner">
                              <img
                                decoding="async"
                                src="assets1\mission.png"
                                alt="alt"
                                title="support-v2-img1"
                              />{" "}
                            </div>
                          </div>
                        </div>

                        <div class="col-xl-6 hidden">
                          <div class="support-one__content">
                            <div class="shape2">
                              <img
                                decoding="async"
                                src="https://bracketweb.com/ontechwp/wp-content/uploads/2023/07/support-v1-shape2-1.png"
                                alt="alt"
                                title="support-v1-shape2"
                              />{" "}
                            </div>
                            <div class="shape3">
                              <img
                                decoding="async"
                                src="https://bracketweb.com/ontechwp/wp-content/uploads/2023/07/support-v1-shape3-1.png"
                                alt="alt"
                                title="support-v1-shape3"
                              />{" "}
                            </div>
                            <div class="sec-title" style={{marginTop:"-80px"}}>
                              <div class="sec-title__tagline">
                                <div class="inner">
                                  <div class="round-box">
                                    <img
                                      decoding="async"
                                      src="https://bracketweb.com/ontechwp/wp-content/uploads/2023/07/sec-title-shape.png"
                                      alt="alt"
                                      title="sec-title-shape"
                                    />{" "}
                                  </div>
                                  <div class="text">
                                    <p class="sec-title__sub-title">
                                      Our Mission
                                    </p>
                                  </div>
                                </div>
                              </div>
                              <h2 class="sec-title__title">
                                Improve Quality <br /> With Technology
                              </h2>
                            </div>

                            <div class="support-one__content-text1">
                              <p class="summary__text" style={{textAlign:"justify"}}>
                                We are taking this opportunity to introduce you
                                to the STTS registered under SHAW TECH
                                TRAINING & SERVICES. The company was founded by
                                a highly experienced Design & Development team
                                with knowledge of the latest CAD/CAM technology
                                in industries. Our company specializes in
                                CAD/CAM & CAE training, as well as consultancy,
                                including engineering services. The team has
                                already trained more than 10,000 students over
                                the last 15 years in various colleges and
                                corporations in India. As you are aware of the
                                need and necessity of computer education in
                                present times, modern businesses rely heavily on
                                computerized technology to efficiently complete
                                vast amounts of tasks. Having decent computer
                                skills means that you can perform tasks that
                                competing candidates may not be able to. This
                                knowledge can result in you getting hired over
                                your competitors.
                              </p>
                            </div>

                            {/* <div class="support-one__content-text2">
                                                            <div class="support-one__content-text2-single ">
                                                                <div class="icon-box">
                                                                    <span aria-hidden="true" class="  icon-buoy-help"></span> </div>
                                                                <div class="text-box">
                                                                    <h3>Tech Solution</h3>
                                                                    <p>There are many variations <br /> of passages of lorem</p>
                                                                </div>
                                                            </div>
                                                            <div class="support-one__content-text2-single mb0">
                                                                <div class="icon-box">
                                                                    <span aria-hidden="true" class="   icon-interview"></span> </div>
                                                                <div class="text-box">
                                                                    <h3>IT Support</h3>
                                                                    <p>There are many variations <br /> of passages of lorem</p>
                                                                </div>
                                                            </div>
                                                        </div> */}
                          </div>
                        </div>
                      </div>
                    </div>
                  </section>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section
        class="elementor-section elementor-top-section elementor-element elementor-element-69c91378 elementor-section-full_width elementor-section-height-default elementor-section-height-default"
        data-id="69c91378"
        data-element_type="section"
      >
        <div class="elementor-container elementor-column-gap-no">
          <div
            class="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-54364ff5"
            data-id="54364ff5"
            data-element_type="column"
          >
            <div class="elementor-widget-wrap elementor-element-populated hidden">
              <div
                class="elementor-element elementor-element-1b5feb25 elementor-widget elementor-widget-ontech-testimonials"
                data-id="1b5feb25"
                data-element_type="widget"
                data-widget_type="ontech-testimonials.default"
              >
                <div class="elementor-widget-container">
                  <section class="testimonial-one">
                    <div class="container" style={{marginBottom:"-80px"}}>
                      <div class="sec-title text-center">
                        <div class="sec-title__tagline">
                          <div class="inner">
                            <div class="round-box">
                              <img
                                decoding="async"
                                src="https://bracketweb.com/ontechwp/wp-content/uploads/2023/07/sec-title-shape.png"
                                alt="alt"
                                title="sec-title-shape"
                              />{" "}
                            </div>
                            <div class="text">
                              <p class="section-title__sub-title">
                            Our Certificates
                              </p>
                            </div>
                          </div>
                        </div>
                        <h2 class="sec-title__title">
                          Our Certificate{" "}
                        </h2>
                        <img
                          src="
                          /assets1/certificate.jpg
                          "
                         
                          style={{ height: "350px",marginLeft:"-50px",marginTop:"40px" }}
                        />
                        <img src="/assets1/msme.jpeg" style={{ height: "350px",marginLeft:"60px",marginTop:"30px" }} />
                      </div>
                    
                    </div>
                  </section>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
     
    </>
  );
};

export default About;
